<template>

    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <div class="message-box">
            <w-transition-fade>
                <w-alert
                    class="my0 text-light"
                    v-if="form.submitted"
                    success
                    no-border
                >
                    The form is valid, ready to send it!
                </w-alert>

                <w-alert
                    class="my0 text-light"
                    v-else-if="form.valid === false"
                    error
                    no-border
                >
                    Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
            </w-transition-fade>
        </div>
       <w-dialog
            v-model="modal.show"
            :fullscreen="modal.fullscreen"
            :width="dialog.width"
            :persistent="modal.persistent"
            :persistent-no-animation="modal.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title> Paparan Butiran {{form_cukai.jenis}}</template>
                <template v-if="form_cukai.code == 2">
                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Nama : 
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.nama}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Pejabat Tanah :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.jabatan}} </div>
                            </div>
                        </w-flex>

                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Alamat :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.alamat}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Daerah :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.daerah}} </div>
                            </div>
                        </w-flex>
                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Mukim/Bandar/Pekan :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.mukim}} </div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Tarikh Daftar :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form_cukai.tarikh_daftar)}}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                     Jenis Hakmilik :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.hm_jenis}} </div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      No. Lot :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.no_lot}} </div>
                            </div>
                        </w-flex>
                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                     No. KP :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.no_kp}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Keluasan :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.keluasan}} {{form_cukai.unit_keterangan}} </div>
                            </div>
                        </w-flex>
                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                     No. Rujukan :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.no_hm}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Kegunaan :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.hm_kegunaan}} </div>
                            </div>
                        </w-flex>

                        <br><br>
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <!-- <th>Jabatan</th>
                                <th>Nama Profil</th> -->
                                <th rowspan="2">Kod Akaun</th>
                                <th colspan="6">amaun (RM)</th>
                            </tr>
                                <th>Cukai</th>
                                <th>Telah Bayar</th>
                                <th>Pelarasan</th>
                                <th>Ampun Hasil</th>
                                <th>Diskaun</th>
                                <th>Baki</th>
                            <tr>

                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(d, index) in cukai">
                               <!--  <td>{{ d.profil_nama }}</td>
                                <td>{{ d.no_hm }}</td> -->
                                <td>
                                    <!-- {{ d.akaun_keterangan }} -->
                                    <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="d.akaun_id"/>
                                 </td>
                                <td align="right">
                                    {{ $zutil.currency(d.rm_debit) }}
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(d.rm_resit) }}
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(d.rm_kredit) }}
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(d.rm_ampun_hasil) }}
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(d.rm_diskaun) }}
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(d.baki) }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6">
                                    <b>Jumlah</b>
                                </td>
                                <td align="right">
                                    <b>{{ $zutil.currency(form_cukai.amaun) }}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </template>
            <template v-else>
                     <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Nama : 
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.nama}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Jabatan :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.jabatan}} </div>
                            </div>
                        </w-flex>

                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Alamat :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.alamat}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      No. Rujukan :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.no_rujukan}} </div>
                            </div>
                        </w-flex>
                        <w-flex justify-left>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      No. KP :
                                  </h5>
                                  <div class="fw-normal my1 fs-1"> {{form_cukai.no_kp}}</div>
                            </div>
                            <div class="xs6">
                                  <h5 class="fw-semibold m0">
                                      Amaun (RM) :
                                  </h5>
                                  <div class="fw-normal my1 fs-1">{{form_cukai.amaun}} </div>
                            </div>
                        </w-flex>

                        <template v-if="form_cukai.code == 5">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <th>No. Bil</th>
                                        <th>Keterangan</th>
                                        <th>Amaun (RM)</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(d, index) in cukai">
                                       <td>
                                           {{d.no_bil}}
                                       </td>
                                       <td>
                                           {{d.caj_keterangan}} {{d.bulan}} - {{d.tahun}}
                                       </td>
                                        <td align="right">
                                            {{ $zutil.currency(d.amaun) }}
                                        </td>
                                        
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <b>Jumlah</b>
                                        </td>
                                        <td align="right">
                                            <b>{{ $zutil.currency(form_cukai.amaun) }}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                
            </template>
            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="modal.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title> Tambah Profil </template>
            <template #default>
                <w-form
                    ref="form"
                    v-model="dialog.valid"
                    @validate="submitProfil"
                    @success="success"
                >
                    <template></template><br />
                     <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat" 
                              name="Alamat" 
                              v-model="form_profil.alamat1" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                            <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                </w-form>
            </template>
            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
                <w-button
                    class="ml1"
                    :loading="dialog.loading"
                    :disabled="dialog.valid === false"
                    @click="$refs.form.validate()"
                    >Simpan</w-button
                >
            </template>
        </w-dialog>

        <w-card bg-color="" class="">
            <h3>Tambah Profil</h3>
            <br /><br />

            <w-flex class="mt3">
                <!-- <z-input
                    label="Profil *"
                    v-model="form.profil_keterangan"
                    name="profil_id"
                    readonly
                    @click="profil"
                /> -->
                <w-input   v-model="form.profil_keterangan" required label="Profil *"   :validators="[validators.required]" @click="profil" />
                <div class="xs1">
                    <w-icon @click="profil">fal fa-search</w-icon>
                    &nbsp;
                    <w-icon @click="dialog.show = true">fal fa-plus</w-icon>
                </div>
            </w-flex>

            <br />
            <w-flex justify-center align-center v-if="form.profil_keterangan">
                        <div class="xs6">
                            <h5 class="fw-semibold m0">Profil :</h5>
                            <!-- {{form.no_id}}  {{form.nama}} -->
                            {{ form.profil_keterangan }}
                        </div>

                        <div class="xs6">
                            <h5 class="fw-semibold m0">Alamat :</h5>
                            {{ form.profil_alamat }} {{ form.poskod }}
                            {{ form.bandar }} {{ form.negeri }}
                        </div>
                    </w-flex>
                    
             </w-card
        ><br />

        <w-card bg-color="" class="">
            <w-flex justify-space-between class="mb4">
                <!-- <div class="xs7"> -->
                <!-- <w-input v-model="form_cari.no_rujukan" name="no_rujukan" label="No Rujukan" /> -->

                <!--  <w-input
                    v-model="form_cari.no_rujukan"
                    name="no_rujukan"
                    label="No Rujukan"
                    @click="profilhm"
                /> -->

                <!-- <div class="xs3">
                    <z-lookup name="akaun" :options="jenis" :sort="false" :cache="false" v-model="form_cari.jenis" label="Jenis Bayaran"/>
                </div> -->
                <div class="xs11">
                <w-input
                    v-model="form_cari.no_rujukan"
                    name="no_rujukan"
                    label="No Rujukan"
                    @change="Detail()"
                />
            </div>
                <!-- </div> -->

                <div class="xs1">
                    <!-- <w-icon @click="Detail()">fal fa-search</w-icon> -->
                    <w-icon>fal fa-search</w-icon>
                    &nbsp;
                    <w-icon @click="profilhm">fal fa-plus</w-icon>
                    <!-- &nbsp;
                    <w-icon v-on:keyup="Detail()">fal fa-qrcode</w-icon> -->

                    <!-- <w-button class="ml1" @click="profilhm">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button> -->
                    <!--  <w-button class="ml1 " @click="Detail()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button> -->
                </div>
            </w-flex>
            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <!-- <w-flex justify-space-between class="mb4">
                <w-input
                    v-model="form_carian.no_rujukan"
                    name="no_rujukan"
                    label="Barcode No Rujukan"
                    v-on:keyup="Detail()"
                />
                <div class="xs1"></div>
            </w-flex> -->
        </w-card>
        <w-alert bg-color="red" color="white"

            class="my0 mb2 text-light"
            v-if="halangan"
            transition="bounce"
            plain
            round
           
            >
            <w-flex class="wrapper">
                {{ halangan }}
                <div class="spacer"></div>
                <w-icon
                md
                color="red"
                bg-color="white"
                 @click="halangan = null" >
                 mdi mdi-close</w-icon>
            </w-flex>
        </w-alert>

        <z-page title="Butiran Bayaran">
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil</td>
                                <td>Jenis</td>
                                <td>Nama Pemilik</td>
                                <td>No. Rujukan</td>
                                <!-- <td>Kod Akaun</td> -->
                                <!-- <td>Butiran</td> -->
                                <td>Amaun (RM)</td>
                                <td>Amaun Bayar (RM)</td>
                                <td>
                                    <!-- <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon> -->
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dat, index) in hm_cukai">
                                <td>
                                    {{index+1}}
                                </td>
                                <td>
                                    {{dat.jenis}}
                                </td>
                                <td>
                                    <!-- <z-lookup
                                        :url="
                                            service_utiliti + 'lookup/jabatan'
                                        "
                                        :sort="false"
                                        :cache="false"
                                        v-model="dat.jabatan_id"
                                    /> -->
                                    {{ dat.nama }}
                                </td>
                                <td>
                                    <!-- <w-input
                                        v-model="dat.no_rujukan"
                                        required
                                    /> -->
                                    {{ dat.no_rujukan }}
                                </td>

                                <td align="right">
                                    {{ $zutil.currency(dat.amaun_asal) }}
                                </td>
                                <td>
                                    <z-money
                                        v-model:originalValue="dat.amaun"
                                        required
                                        v-on:keyup="cekAmaunCukai(dat)"
                                    />
                                </td>
                                <td>
                                    <w-icon
                                        class="mr1"
                                        @click="removeCukai(index)"
                                        >fal fa-trash</w-icon
                                    >
                                    &nbsp;
                                    <w-icon
                                        tile
                                        @click="show(dat)"
                                        title="Papar"
                                        >fal fa-eye</w-icon
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">Jumlah (RM)</td>
                                <td align="right"><b>{{$zutil.currency(amaun_jumlah_cukai)}}</b></td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">
                                    Penggenapan (RM)
                                </td>
                                <td align="right"><b>0</b></td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">
                                    Jumlah Dibayar (RM)
                                </td>
                                <td align="right">
                                    <b>{{
                                        $zutil.currency(amaun_jumlah_cukai)
                                    }}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
        </z-page>

        <z-page title="Butiran Bayaran (Bil)">
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil</td>
                                <td>Jenis</td>
                                <td>Nama Pemilik</td>
                                <td>No. Bil</td>
                                <td>amaun (RM)</td>
                                <td>Amaun Bayar (RM)</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in butiran">
                                <td>{{index+1}}</td>
                                <td>{{ dt.jenis }}</td>
                                <td>{{ dt.profil_nama }}</td>
                                <td>{{ dt.no_rujukan }}</td>
                                
                                <td align="right">
                                    {{ $zutil.currency(dt.amaun) }}
                                </td>
                                <td :class="{ hide: !seen }">
                                <!-- <td> -->
                                    <z-money
                                        v-model:originalValue="dt.amaun"
                                        v-on:keyup="cekBakiButiran(dt)"
                                        readonly
                                    />
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(dt.amaun) }}
                                </td>
                                <td>
                                    <w-icon
                                        class="mr1"
                                        @click="removeButiran(index)"
                                        >fal fa-trash</w-icon
                                    >
                                    &nbsp;
                                    <w-icon
                                        tile
                                        @click="butiranInbois(dt)"
                                        title="Papar"
                                        >fal fa-eye</w-icon
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">Jumlah (RM)</td>
                                <td align="right"><b>{{ $zutil.currency(amaun_butiran) }}</b></td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">
                                    Penggenapan (RM)
                                </td>
                                <td align="right"><b>0</b></td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">
                                    Jumlah Dibayar (RM)
                                </td>
                                <td align="right">
                                    <b>
                                        {{ $zutil.currency(amaun_butiran) }}
                                    </b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
        </z-page>
        <w-form
            class=""
            v-model="form.valid"
            v-model:errors-count="form.errorsCount"
            @validate="submitResit"
            @success="onSuccess"
        >
            <z-page title="Cara Bayaran">
                <w-flex justify-center align-center class="mt5">
                    <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Cara Bayaran </td>
                                    <td>Tarikh EFT</td>
                                    <td>Bank</td>
                                    <td>Cawangan Bank</td>
                                    <td>No Cek / Bank Draf / Transaksi Bank</td>
                                    <td>Tarikh Cek/ Bank Draf</td>
                                    <td>Amaun (RM)</td>
                                    <!-- <td>
                                        <w-icon class="mr1" @click="addBayar"
                                            >fal fa-plus</w-icon
                                        >
                                    </td> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in form.cara_bayaran">
                                    <!-- <tr> -->
                                    <td>
                                       <!--  <z-lookup
                                            v-if="lkp_kaunter_id"
                                            :key="'cara-bayaran-' + lkp_kaunter_id"
                                            :url="
                                                service_utiliti +
                                                'lookup/cara_bayaran_kaunter/' +
                                                lkp_kaunter_id
                                            "
                                            :sort="false"
                                            :cache="false"
                                            v-model="d.lkp_cara_bayaran_id"
                                            required
                                            :validators="[validators.required]"
                                        /> -->

                                        <z-lookup
                                            :url="
                                                service_utiliti +
                                                'lookup/cara_bayar_kaunter'
                                            "
                                            :sort="false"
                                            :cache="false"
                                            v-model="d.lkp_cara_bayaran_id"

                                            required
                                            :validators="[validators.required]"
                                        />
                                    </td>
                                    <td>
                                        <template v-if="d.lkp_cara_bayaran_id == 32" >
                                               <z-input 
                                                  name="tarikh_eft" 
                                                  v-model="d.tarikh_eft" 
                                                  type="date"  :validators="[
                                                        validators.required,
                                                    ]"/>
                                        </template>
                                    </td>

                                    <td>

                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_bank  == 1" >
                                            <z-lookup
                                                :url="
                                                    service_utiliti +
                                                    'lookup/bank'
                                                "
                                                :sort="false"
                                                :cache="false"
                                                v-model="d.lkp_bank_id"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            />
                                        </template>
                                        </template>
                                    </td>
                                     <td>
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_cek  == 1" >
                                            <w-input
                                                class="mb4"
                                                v-model="d.cawangan_bank"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                                
                                            />
                                        </template>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_dokumen  == 1" >
                                            <w-input
                                                class="mb4"
                                                v-model="d.no_dokumen"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                                
                                            />
                                        </template>
                                        </template>
                                    </td>
                                     <td>
                                        <template v-for="(c, index) in cara_bayar">
                                            <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_cek  == 1" >
                                               <z-input 
                                                  name="tarikh_cek" 
                                                  v-model="d.tarikh_cek" 
                                                  type="date"  :validators="[
                                                        validators.required,
                                                    ]"/>
                                            </template>
                                        </template>
                                    </td>
                                    <td align="right" >
                                        <!-- <z-money
                                            v-model:originalValue="d.amaun"
                                            required
                                            v-on:keyup="cekAmaunBayar(d)"
                                            validators="[validators.required]"
                                        /> -->
                                        {{ $zutil.currency(d.amaun) }}
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_terminal  == 1" >
                                        <w-button v-if="terminal && terminal.ip_address && d.lkp_cara_bayaran_id && d.lkp_cara_bayaran_id != 4 && hantarTerminal == 1"
                                            class="my1 "
                                            @click="sendTerminal(d)">
                                            Hantar Terminal
                                        </w-button><br>
                                        </template>
                                        </template>
                                        <span class="w-form-el__error error w-form-el__error w-form-el__error">{{error_termilan}}</span>
                                        
                                    </td>
                                    <!-- <td>
                                        <w-icon
                                            class="mr1"
                                            @click="removeBayar(index)"
                                            >fal fa-trash</w-icon
                                        >
                                    </td> -->
                                </tr>
                                <tr>
                                    <td colspan="6" align="right">
                                        Jumlah (RM)
                                    </td>
                                    <td align="right">
                                        <b>
                                            {{
                                                $zutil.currency(
                                                    amaun_jumlah_cukai +
                                                        amaun_butiran
                                                )
                                            }}
                                        </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6" align="right">
                                        Jumlah Perlu Dibayar(RM)
                                    </td>
                                    <td align="right">
                                        <b>
                                            <!-- {{
                                            $zutil.currency(
                                                amaun_jumlah_cukai +
                                                    amaun_butiran -
                                                    amaun_bayaran
                                            )
                                        }} -->
                                        {{
                                                $zutil.currency(
                                                    amaun_jumlah_cukai +
                                                        amaun_butiran
                                                )
                                            }}
                                    </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6" align="right">
                                        Baki(RM)
                                    </td>
                                    <td align="right">
                                        <b>{{
                                            $zutil.currency(
                                                amaun_bayaran -
                                                    (amaun_jumlah_cukai +
                                                        amaun_butiran)
                                            )
                                        }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>
            </z-page>

            <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <template v-if="$zutil.can('Terimaan Simpan') || 1">
                    <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                        Hantar
                    </w-button>
                </template>
            </w-flex>
        </w-form>

        <w-dialog
            v-model="dialogProfil.show"
            :fullscreen="dialogProfil.fullscreen"
            :width="dialogProfil.width"
            :persistent="dialogProfil.persistent"
            :persistent-no-animation="dialogProfil.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
            </template>
            <div class="page-wrapper-portal">
                <w-flex justify-center align-center>
                    <div class="xs8">
                        <w-input
                            label="No KP | Nama (Carian minimun 2 aksara)"
                            v-model="carian_profil.q"
                        >
                        </w-input>
                    </div>
                    <div class="xs4">
                        <w-button class="ml1" @click="cariProfil"
                            >Cari</w-button
                        >
                    </div>
                </w-flex>
                <div class="table-profil-scrol">
                    <table class="w-table">
                        <thead>
                            <tr>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    No
                                </th>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    No KP | Nama
                                </th>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Pilih
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in profils">
                                <td class="w-table__cell text-left">
                                    {{ index + 1 }}
                                </td>
                                <td class="w-table__cell">
                                    {{ dt.label }}
                                </td>
                                <td class="w-table__cell text-right">
                                    <w-radio
                                        class="mr2"
                                        v-model="form.profil_id"
                                        :return-value="dt.value"
                                        @click="pilihProfil(dt)"
                                    ></w-radio>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogProfil.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

        <w-dialog
            v-model="dialogProfilhm.show"
            :fullscreen="dialogProfilhm.fullscreen"
            :width="dialogProfilhm.width"
            :persistent="dialogProfilhm.persistent"
            :persistent-no-animation="dialogProfilhm.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil Terimaan
            </template>
            <div class="page-wrapper-portal">
                <w-flex justify-center align-center>
                    <div class="xs8">
                        <w-input
                            label="No. KP | Nama | No. Rujukan | No. Lot | No. Bil (Carian minimun 2 aksara)"
                            v-model="carian_profil_hm.q"
                        >
                        </w-input>
                    </div>
                    <div class="xs4">
                        <w-button class="ml1" 
                    :loading="dialog.loading" @click="cariProfilhm"
                            >Cari</w-button
                        >
                    </div>
                </w-flex>
                <br /><br />
                <div class="table-profil-scrol">
                    <z-page title="Butiran Bayaran (Cukai)">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Lot/ No. PT
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_akaun"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in draf_akaun">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.profil_nama }}
                                    </td>
                                    <!-- <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_hm }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.no_lot }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_akaun"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                                 
                            </tbody>
                        </table>
                    </z-page>
                    <br><br>

                    <z-page title="Butiran Bayaran (Bil Pelbagai)">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_inbois"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in draf_inbois">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{dt.profil_no}} | {{ dt.profil_nama }}
                                    </td>
                                    <!--  <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_inbois }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_inbois" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_inbois" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_inbois"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </z-page>
                    <z-page title="Butiran Bayaran Perumahan">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                       No. Akaun
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_perum"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr v-for="(dt, index) in draf_perum">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.nama }}
                                    </td>
                                    <!-- <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_akaun }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.no_id }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.kadar_bulanan) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_perum"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                                 
                            </tbody>
                        </table>
                    </z-page>

                    <z-page title="Butiran Bayaran Pendidikan">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                       No. Akaun
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_pendidik"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr v-for="(dt, index) in draf_pendidik">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.NAMA_PENUH }}
                                    </td>
                                    <!-- <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.NO_LBNK }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.IC_BARU }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.ANSURAN_BULANAN) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_pendidik"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                                 
                            </tbody>
                        </table>
                    </z-page>
                    <br >
                     <z-page title="Butiran Bayaran Tuntutan Bantuan">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                       No. Akaun
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_tuntutan"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr v-for="(dt, index) in draf_tuntutan">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.nama }}
                                    </td>
                                    <!-- <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_rujukan }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.no_id }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.jumlah_amaun) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_tuntutan"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                                 
                            </tbody>
                        </table>
                    </z-page>
                    <br >
                    
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="hantarRujukan"
                    >Hantar</w-button
                >
                &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogProfilhm.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

        <w-dialog
            v-model="dialogButiran.show"
            :fullscreen="dialogButiran.fullscreen"
            :width="dialogButiran.width"
            :persistent="dialogButiran.persistent"
            :persistent-no-animation="dialogButiran.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Paparan Butiran Bil
            </template>
            <div class="page-wrapper-portal">
                <div class="table-profil-scrol">
                    <w-flex justify-left>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Nama : 
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{form_butiran.profil_nama}}</div>
                        </div>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Jabatan :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{form_butiran.jabatan}} </div>
                        </div>
                    </w-flex>

                    <w-flex justify-left>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Alamat :
                              </h5>
                              <div class="fw-normal my1 fs-1"> 
                                {{form_butiran.alamat.alamat1}},
                              {{form_butiran.alamat.poskod ? form_butiran.alamat.poskod.keterangan: ''}},
                              {{form_butiran.alamat.poskod ? form_butiran.alamat.bandar.keterangan: ''}},
                              {{form_butiran.alamat.poskod ? form_butiran.alamat.negeri.keterangan: ''}}</div>
                        </div>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  No. Bil :
                              </h5>
                              <div class="fw-normal my1 fs-1">
                                    {{form_butiran.no_rujukan}}
                                </div>
                        </div>
                    </w-flex>
                    <w-flex justify-left>
                        <div class="xs6">
                              <h5 class="fw-semibold m0">
                                 No. KP :
                              </h5>
                              <div class="fw-normal my1 fs-1"> 
                                        {{form_butiran.no_kp}}</div>
                        </div>
                        <div class="xs6" v-if="form_butiran.code == 1">
                              <h5 class="fw-semibold m0">
                                  Tarikh Bil :
                              </h5>
                              <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form_butiran.tarikh_inbois)}}  </div>
                        </div>
                         <div class="xs6" v-else>
                              <h5 class="fw-semibold m0">
                                  Amaun (RM) :
                              </h5>
                              <div class="fw-normal my1 fs-1">{{ $zutil.currency(form_butiran.amaun) }}  </div>
                        </div>
                    </w-flex>
                   
                <br><br>
                <template v-if="form_butiran.code == 1">

                <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                               <!--  <td>Nama Pemilik</td>
                                <td>No. Rujukan</td> -->
                                <td>Kod Akaun</td>
                                <td>Vot</td>
                                <td>amaun (RM)</td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(da, index) in butir">
                                <!-- <td>{{ d.profil_nama }}</td>
                                <td>{{ d.no_inbois }}</td> -->
                                <td>
                                    <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' @pilih="Vot_akaun(da)" :sort="false" :cache="false" v-model="da.akaun_id"/>
                                </td>
                                <td>
                                   <template v-if="da.vot_id">
                                        <template v-if="da.ind_vot_id">
                                           <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="d.vot_id"  />
                                       </template>
                                       <template v-else>
                                           <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="da.vot_id"  />
                                       </template>
                                   </template>
                                   <template v-else>
                                       <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="da.vot_id"  />
                                   </template>
                                                
                                                
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(da.amaun) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogButiran.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>
        <w-overlay
              v-model="showOverlay"
              :persistent= true>
              
            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            </w-overlay>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            lkp_kaunter_id: null,
            kaunter: {},
            terminal : {},
            kaunter : {},
            showOverlay: false,
            persistent: false,
            pilih_akaun: false,
            pilih_inbois: false,
            halangan : null,
            halang : null,
            resourceurl: this.service_kutipan + "terimaan",
            reload: true,
            hm_cukai: [],
            butiran: [],
            error_termilan : null,
            form_carian: {},
            amaun_bayaran: 0,
            amaun_butiran: 0,
            cukai: [],
            butir: [],
            draf_akaun: [],
            draf_inbois: [],
            draf_perum: [],
            draf_pendidik: [],
            draf_tuntutan: [],
            amaun_jumlah_cukai: 0,
            form_profil: {},
            form_cari: {},
            carian_profil: { q: "" },
            profils: [],
            hantarTerminal : 1,
            loading : false,
            kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                form: { nama: "", email: "" },
            },

            dialogButiran: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                butir: [],
                // form: { inbois_id: "",
                //     amaun: "",
                //     no_inbois: "",
                //     jabatan_id: "",
                //     profil_nama: "",
                //     alamat : "",
                //     jabatan : "",
                //     no_kp: "",
                //     tarikh_inbois: ""},
            },
            data_modal : {
                    inbois_id: "",
                    amaun: "",
                    no_inbois: "",
                    jabatan_id: "",
                    profil_nama: "",
                    alamat : "",
                    jabatan : "",
                    no_kp: "",
                    tarikh_inbois: "",
            },
            connection: null,
            form_profil_hm: {},
            carian_profil_hm: { q: "" },
            profils: [],
            dialogProfilhm: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                pilih_akaun: false,
                pilih_inbois: false,
                form: { nama: "", email: "" },
            },
            // terimaan : {},
            // terminal : {},
            // kaunter : {},
            cara_bayaran : [],
            bank : [],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Terimaan", route: "/kutipan/terimaan" },
            ],
            jenis: [
                { label: "CUKAI", value: 2 },
                { label: "BIL PELBAGAI", value: 1 },
                { label: "PENDIDIKAN", value: 3 },
                { label: "TUNTUTAN", value: 4 },
                { label: "PERUMAHAN", value: 5 },
            ],
        };
    },
    
    created: function() {
        
        

    },

    methods: {

        sendTerminal(d) {
            if(this.terminal && this.terminal.ip_address){
                console.log(this.connection);
                if ( !this.connection ) {
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                    if ( !this.connection ) {
                        this.error_termilan = "Terminal POS tidak berjaya disambung";
                    }
                }
                if ( this.connection.readyState != 1 ) {
                    this.connection.close();
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                }
                if(this.connection.readyState == 1){
                    this.hantarTerminal = 0
                    var message = '{"type":"TXNREQ", "parameters":{"transactionType":"0200", "subTranType":"00", "paymentMethod":"card", "amount":"'+d.amaun+'", "amountOther":"0.00", "reference":"'+this.terimaan.id+'"} }';
                    this.connection.send(message);
                    this.connection.onmessage = function(event) {
                      console.log(event);
                      console.log(event.data);

                    console.log(event.data);
                    console.log(event.data.parameters)
                      if(event.data.parameters){
                          d.no_dokumen = event.data.parameters.traceNo
                      }
                      if(event.parameters){
                          d.no_dokumen = event.parameters.traceNo
                      }
                    }
                }else{
                    // alert('tidak Connect');
                    this.error_termilan = "Terminal POS tidak berjaya disambung";
                }
            }
        },

        bukaKaunter() {
                this.$zcomm
                    .post(
                        this.service_kutipan + "bukakaunter",
                        {}
                    )
                    .then((res) => {
                        if (res.ind_buka != 1) {
                            this.$inertia.visit(
                            this.$route("kutipan.kaunter.buka")
                            );
                        }
                        this.terminal = res.terminal
                        this.terimaan = res.terimaan
                        this.kaunter = res.kaunter
                        // Ambil ID kaunter
                        this.lkp_kaunter_id = this.kaunter.lkp_kaunter_id;
                        this.soket()
                    });

        },

        caraBayar() {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/cara_bayar",
                        {}
                    )
                    .then((res) => {
                        
                        this.cara_bayar = res
                       
                    });

        },


        soket(){

            if(this.terminal && this.terminal.ip_address){
                console.log("Starting connection to WebSocket Server")
                this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                if ( this.connection.readyState != 1 ) {
                    this.connection.close();
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                }
                
                this.connection.onmessage = function(event) {
                  console.log(event);

                    console.log(event.data);
                    console.log(event.data.parameters)
                   for (var i in this.form.cara_bayaran) {
                    if(event.data.parameters){
                        this.form.cara_bayaran[i].no_dokumen  = event.data.parameters.traceNo
                    }
                    if(event.parameters){
                        this.form.cara_bayaran[i].no_dokumen  = event.parameters.traceNo
                    }
                   }
                }

                this.connection.onopen = function(event) {
                  console.log(event)
                  console.log("Successfully connected to the echo websocket server...")
                }
            }
        },

        show(dat) {
            this.form_cukai = dat;
            this.cukai = dat.hm_cukai;
            this.modal.show = true;
        },


        // showButiran(dt) {
        //     this.butir = dt.butiran;
        //     this.modal.showButir = true;
        // },

        butiranInbois(dt) {
            // console.log(dt);
            this.form_butiran = dt;
            this.butir = dt.butiran;
            this.dialogButiran.show = 1;
            // this.getBayaran();
        },

        addBayar() {
            this.form.cara_bayaran.push({
                lkp_cara_bayaran_id: null,
                lkp_bank_id: null,
                no_dokumen: null,
                cawangan_bank: null,
                tarikh_cek: null,
                amaun: null,
            });
        },

        removeBayar(index) {
            this.form.cara_bayaran.splice(index, 1);
        },

        removeCukai(index) {
            this.hm_cukai.splice(index, 1);

            this.cekAmaunCukai();
        },

        removeButiran(index) {
            this.butiran.splice(index, 1);

            this.cekAmaunButiran();
        },

        cekBakiButiran(dt) {
            dt.baki = dt.amaun;

            this.cekAmaunButiran();
        },

        cekAmaunBayar(d) {
            d.baki = d.amaun;

            this.cekAmaunTotalBayar();
        },

        cekAmaunTotalBayar() {
            this.amaun_bayaran = 0;
            for (var i in this.form.cara_bayaran) {
                this.amaun_bayaran =
                    this.amaun_bayaran +
                    parseFloat(this.form.cara_bayaran[i].amaun);
            }
            // this.cekJumlahBayar()
        },

        cekAmaunButiran() {
            this.amaun_butiran = 0;
            for (var i in this.butiran) {
                this.amaun_butiran =
                    this.amaun_butiran + parseFloat(this.butiran[i].amaun);
            }
            this.totalKenaBayar()
            // this.cekJumlahBayar()
        },

        // for(i in this.form.butiran) { this.amaun_butiran += this.form.butiran[i].amaun; }

        cekAmaunCukai() {
            this.amaun_jumlah_cukai = 0;
            for (var i in this.hm_cukai) {
                this.amaun_jumlah_cukai =
                    this.amaun_jumlah_cukai +
                    parseFloat(this.hm_cukai[i].amaun);
            }
            this.totalKenaBayar()
        },

        // cekJumlahBayar(){
        //   resit.amaun = form.amaun - resit.amaun
        //   // for (var i in this.form.butiran) {
        //     // }
        // },

        cekKeluasan(dat) {
            form.keluasan = dat.amaun_debit - dat.amaun_diskaun;
            this.cekTotal();
            // for (var i in this.form.butiran) {
            // }
        },

        Detail() {
            this.halangan = null
            if(this.loading == false){
           
            this.halang = null
            // if(this.form_cari.jenis){
             this.loading = true
            // this.$zcomm.get(this.service_kutipan +"terimaan" +"?no_rujukan=" +this.form_cari.no_rujukan+'&jenis='+this.form_cari.jenis)
             this.$zcomm.get(this.service_kutipan +"terimaan" +"?no_rujukan=" +this.form_cari.no_rujukan)
                .then((res) => {
                    console.log(res.data);
                    this.loading = false
                    this.form_cari.no_rujukan = null
                    if(res.code > 0){
                        if(res.code == 1){
                            if (res.data.butiran) {
                                // this.form.inbois_id = res.data.id;
                                // // this.form.butiran = res.data.butiran;
                                // this.form.amaun = res.data.amaun;
                                // this.form.no_inbois = res.data.no_inbois;
                                // this.form.jabatan_id = res.data.jabatan.id;
                                // this.form.profil_nama = res.data.profil_nama;
                                // this.form.alamat = res.data.alamat;
                                // this.form.jabatan = res.data.jabatan_keterangan;
                                // this.form.no_kp = res.data.profil_no;
                                // this.form.tarikh_inbois = res.data.tarikh_inbois;
                                // for (var i in res.data.butiran) {
                                // this.form.butiran.push( res.data.butiran[i]);
                                var proses = 1;
                                for (var j in this.butiran) {
                                    if(res.data.no_inbois == this.butiran[j].no_rujukan){
                                        proses = 0;
                                    }
                                }
                                if(proses == 1){
                                    this.butiran.push({
                                        code : 1,
                                        jenis : 'BIL PELBAGAI',
                                        jabatan_id: res.data.jabatan.id,
                                        no_rujukan: res.data.no_inbois,
                                        akaun_id: res.data.akaun_id,
                                        amaun: res.data.amaun,
                                        profil_id: res.data.profil_id,
                                        butiran: res.data.butiran,
                                        baki: res.data.amaun,
                                        profil_nama: res.data.profil.nama,
                                        id: res.data.id,
                                        sumber_akaun_id: res.data.sumber_akaun_id,
                                        vot_id: res.data.vot_id,
                                        alamat : res.data.profil.alamat,
                                        no_kp : res.data.profil.no_id,
                                        jabatan: res.data.jabatan.keterangan,
                                        tarikh_inbois : res.data.tarikh_inbois,
                                    });
                                }
                                // }

                                this.form.butiran = this.butiran;
                            } 
                        }
                        if(res.code == 2){ 

                            if(res.data.flag_halangan_id == null){ 

                                // this.form.hm_akaun_id = res.data.id;
                                // // this.form.hm_cukai = res.data.hm_cukai;
                                // this.form.profil_nama = res.data.profil_nama;
                                // this.form.keluasan = res.data.keluasan;
                                // this.form.no_hm = res.data.no_hm;
                                // this.form.jabatan_id = res.data.jabatan.id;
                                // this.form.alamat = res.data.alamat;
                                // this.form.daerah = res.data.daerah_keterangan;
                                // this.form.hm_jenis = res.data.hm_jenis_keterangan;
                                // this.form.hm_kegunaan = res.data.hm_kegunaan_keterangan;
                                // this.form.mukim = res.data.mukim_keterangan;
                                // this.form.tarikh_daftar = res.data.tarikh_daftar;
                                // this.form.no_lot = res.data.no_lot;
                                // this.form.jabatan = res.data.jabatan_keterangan;
                                // this.form.nama = res.data.nama;
                                // this.form.no_kp = res.data.no_kp;
                                // this.form.unit_keterangan = res.data.unit_keterangan;
                                // this.form.amaun = res.data.amaun;


                                var proses = 1;
                                for (var j in this.hm_cukai) {
                                    if(res.data.no_hm == this.hm_cukai[j].no_rujukan){
                                        proses = 0;
                                    }

                                }
                                if(proses == 1){
                                    this.hm_cukai.push({
                                        code : 2,
                                        jenis : 'CUKAI',
                                        jabatan_id: res.data.jabatan_id,
                                        no_rujukan: res.data.no_hm,
                                        amaun_asal: res.data.amaun,
                                        amaun: res.data.amaun,
                                        profil_id: res.data.profil_id,
                                        hm_cukai: res.data.hm_cukai,
                                        baki: res.data.amaun,
                                        profil_nama: res.data.profil_nama,
                                        nama: res.data.nama,
                                        id: res.data.id,
                                        rm_debit: res.data.rm_debit,
                                        rm_kredit: res.data.rm_kredit,
                                        rm_resit: res.data.rm_resit,
                                        rm_diskaun: res.data.rm_diskaun,
                                        rm_ampun_hasil: res.data.rm_ampun_hasil,
                                        baki: res.data.baki,
                                        sumber_akaun_id: res.data.sumber_akaun_id,
                                        jabatan : res.data.jabatan,
                                        alamat : res.data.alamat,
                                        daerah : res.data.daerah,
                                        mukim : res.data.mukim,
                                        tarikh_daftar : res.data.tarikh_daftar,
                                        hm_jenis : res.data.hm_jenis,
                                        no_lot : res.data.no_lot,
                                        unit_keterangan :  res.data.unit,
                                        keluasan :  res.data.keluasan,
                                        no_hm :  res.data.no_hm,
                                        no_kp :  res.data.no_kp,
                                        hm_kegunaan :  res.data.hm_kegunaan,
                                        is_petak: res.data.is_petak,
                                    });
                                    
                                    this.form.hm_cukai = this.hm_cukai;
                                }
                            }else{
                                this.halangan = res.data.halangan_keterangan;
                                
                            }
                        }
                        if(res.code == 3){ 
                            for (var k in res.data) {
                                 
                                
                                var proses = 1;
                                for (var j in this.hm_cukai) {
                                    if(res.data[k].NO_LBNK == this.hm_cukai[j].no_rujukan){
                                        proses = 0;
                                    }
                                }
                                if(proses == 1){
                                    // this.butiran.push({
                                    //     code : 3,
                                    //     jenis : 'PENDIDIKAN',
                                    //     jabatan_id: 160,
                                    //     no_rujukan: res.data[k].NO_LBNK,
                                    //     akaun_id: null,
                                    //     amaun: res.data[k].ANSURAN_BULANAN,
                                    //     profil_id: res.data[k].profil_id,
                                    //     butiran: [],
                                    //     baki: res.data[k].ANSURAN_BULANAN,
                                    //     profil_nama: res.data[k].NAMA_PENUH,
                                    //     id: res.data[k].model_id,
                                    //     sumber_akaun_id: null,
                                    //     vot_id: null,
                                    //     alamat : res.data[k].ALAMAT_SURAT,
                                    //     no_kp : res.data[k].IC_BARU, 
                                    //     jabatan: null,
                                    //     tarikh_inbois : null,
                                    // });
                                    this.hm_cukai.push({
                                        code : 3,
                                        jenis : 'PENDIDIKAN',
                                        jabatan_id: 160,
                                        no_rujukan: res.data[k].NO_LBNK,
                                        amaun_asal: res.data[k].ANSURAN_BULANAN,
                                        amaun: res.data[k].ANSURAN_BULANAN,
                                        profil_id: res.data[k].profil_id,
                                        hm_cukai: [],
                                        baki: res.data[k].ANSURAN_BULANAN,
                                        profil_nama: res.data[k].NAMA_PENUH,
                                        nama: res.data[k].NAMA_PENUH,
                                        id: res.data[k].model_id,
                                        rm_debit: null,
                                        rm_kredit: null,
                                        rm_resit: null,
                                        rm_diskaun: null,
                                        rm_ampun_hasil: null,
                                        sumber_akaun_id: null,
                                        alamat : res.data[k].ALAMAT_SURAT,
                                        no_kp : res.data[k].IC_BARU, 
                                    });
                                }
                                this.form.hm_cukai = this.hm_cukai;
                            }

                            for (var h in res.data_tuntut) {
                                var proses = 1;
                                for (var j in this.hm_cukai) {
                                    if(res.data_tuntut[h].no_rujukan == this.hm_cukai[j].no_rujukan){
                                        proses = 0;
                                    }
                                }
                                if(proses == 1){
                                    // this.hm_cukai.push({
                                    //     code : 4,
                                    //     jenis : 'TUNTUTAN',
                                    //     jabatan_id: 160,
                                    //     no_rujukan: res.data_tuntut[h].no_rujukan,
                                    //     akaun_id: null,
                                    //     amaun: res.data_tuntut[h].jumlah_amaun,
                                    //     profil_id: res.data_tuntut[h].profil_id,
                                    //     butiran: [],
                                    //     baki: res.data_tuntut[h].jumlah_baki,
                                    //     profil_nama: res.data_tuntut[h].nama,
                                    //     id: res.data_tuntut[h].model_id,
                                    //     sumber_akaun_id: null,
                                    //     vot_id: null,
                                    //     alamat : res.data_tuntut[h].alamat,
                                    //     no_kp : res.data_tuntut[h].no_id, 
                                    //     // lkp_tuntutan_bantuan_transaksi_id : 1, 
                                    //     jabatan: null,
                                    //     tarikh_inbois : null,
                                    // });
                                    this.hm_cukai.push({
                                        code : 4,
                                        jenis : 'TUNTUTAN',
                                        jabatan_id: 160,
                                        no_rujukan: res.data_tuntut[h].no_rujukan,
                                        amaun_asal: res.data_tuntut[h].jumlah_amaun,
                                        amaun: res.data_tuntut[h].jumlah_amaun,
                                        profil_id: res.data_tuntut[h].profil_id,
                                        hm_cukai: [],
                                        baki: res.data_tuntut[h].jumlah_baki,
                                        profil_nama: res.data_tuntut[h].nama,
                                        nama: res.data_tuntut[h].nama,
                                        id: res.data_tuntut[h].model_id,
                                        rm_debit: null,
                                        rm_kredit: null,
                                        rm_resit: null,
                                        rm_diskaun: null,
                                        rm_ampun_hasil: null,
                                        sumber_akaun_id: null,
                                        alamat : res.data_tuntut[h].alamat,
                                        no_kp : res.data_tuntut[h].no_id, 
                                    });
                                }
                                this.form.hm_cukai = this.hm_cukai;
                            }

                            for (var p in res.data_perum) {
                                var proses = 1;
                                for (var j in this.hm_cukai) {
                                    if(res.data_perum[p].no_akaun == this.hm_cukai[j].no_rujukan){
                                        proses = 0;
                                    }
                                }
                                if(proses == 1){
                                    // this.butiran.push({
                                    //     code : 5,
                                    //     jenis : 'PERUMAHAN',
                                    //     jabatan_id: 15,
                                    //     no_rujukan: res.data_perum[p].no_akaun,
                                    //     akaun_id: null,
                                    //     amaun: res.data_perum[p].kadar_bulanan,
                                    //     profil_id: res.data_perum[p].profil_id,
                                    //     butiran: [],
                                    //     baki: res.data_perum[p].amaun_baki,
                                    //     profil_nama: res.data_perum[p].nama,
                                    //     id: res.data_perum[p].model_id,
                                    //     sumber_akaun_id: null,
                                    //     vot_id: null,
                                    //     alamat : res.data_perum[p].alamat,
                                    //     no_kp : res.data_perum[p].no_id, 
                                    //     jabatan: null,
                                    //     tarikh_inbois : null,
                                    // });
                                    this.hm_cukai.push({
                                        code : 5,
                                        jenis : 'PERUMAHAN',
                                        jabatan_id: 15,
                                        no_rujukan: res.data_perum[p].no_akaun,
                                        amaun_asal: res.data_perum[p].kadar_bulanan,
                                        amaun: res.data_perum[p].kadar_bulanan,
                                        profil_id: res.data_perum[p].profil_id,
                                        // hm_cukai: [],

                                        hm_cukai: res.data_perum[p].perumahan_bil,
                                        baki: res.data_perum[p].amaun_baki,
                                        profil_nama: res.data_perum[p].nama,
                                        nama: res.data_perum[p].nama,
                                        id: res.data_perum[p].model_id,
                                        rm_debit: null,
                                        rm_kredit: null,
                                        rm_resit: null,
                                        rm_diskaun: null,
                                        rm_ampun_hasil: null,
                                        sumber_akaun_id: null,
                                        alamat : res.data_perum[p].alamat,
                                        no_kp : res.data_perum[p].no_id, 
                                    });
                                }
                                this.form.hm_cukai = this.hm_cukai;
                            }
                        }
                        // if(res.code == 4){ 
                        //     for (var h in res.data) {
                                
                                
                        //         var proses = 1;
                        //         for (var j in this.butiran) {
                        //             if(res.data[h].no_rujukan == this.butiran[j].no_rujukan){
                        //                 proses = 0;
                        //             }
                        //         }
                        //         if(proses == 1){
                        //             this.butiran.push({
                        //                 code : 4,
                        //                 jenis : 'TUNTUTAN',
                        //                 jabatan_id: 160,
                        //                 no_rujukan: res.data[h].no_rujukan,
                        //                 akaun_id: null,
                        //                 amaun: res.data[h].jumlah_amaun,
                        //                 profil_id: res.data[h].profil_id,
                        //                 butiran: [],
                        //                 baki: res.data[h].jumlah_baki,
                        //                 profil_nama: res.data[h].nama,
                        //                 id: res.data[h].model_id,
                        //                 sumber_akaun_id: null,
                        //                 vot_id: null,
                        //                 alamat : res.data[h].alamat,
                        //                 no_kp : res.data[h].no_id, 
                        //                 // lkp_tuntutan_bantuan_transaksi_id : 1, 
                        //                 jabatan: null,
                        //                 tarikh_inbois : null,
                        //             });
                        //         }
                        //         this.form.butiran = this.butiran;
                        //     }
                        // }
                        // if(res.code == 5){ 
                        //     for (var k in res.data) {
                                 
                                
                        //         var proses = 1;
                        //         for (var j in this.butiran) {
                        //             if(res.data[k].no_akaun == this.butiran[j].no_rujukan){
                        //                 proses = 0;
                        //             }
                        //         }
                        //         if(proses == 1){
                        //             this.butiran.push({
                        //                 code : 5,
                        //                 jenis : 'PERUMAHAN',
                        //                 jabatan_id: 15,
                        //                 no_rujukan: res.data[k].no_akaun,
                        //                 akaun_id: null,
                        //                 amaun: res.data[k].kadar_bulanan,
                        //                 profil_id: res.data[k].profil_id,
                        //                 butiran: [],
                        //                 baki: res.data[k].amaun_baki,
                        //                 profil_nama: res.data[k].nama,
                        //                 id: res.data[k].model_id,
                        //                 sumber_akaun_id: null,
                        //                 vot_id: null,
                        //                 alamat : res.data[k].alamat,
                        //                 no_kp : res.data[k].nama, 
                        //                 jabatan: null,
                        //                 tarikh_inbois : null,
                        //             });
                        //         }
                        //         this.form.butiran = this.butiran;
                        //     }
                        // }
                    }else{
                        this.halangan = res.halangan;
                    }

                    this.cekAmaunButiran();
                    this.cekAmaunCukai();
                });
            // }
            }
        },

        submitResit() {
            // if (this.$refs.form.validate()) {
            if (this.form.valid == true) {
                this.form.valid = false
                this.loading = true
                this.showOverlay= true
                this.$zcomm
                    .post(this.resourceurl, this.form)
                    .then((res) => {
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd();
                        }

                        this.$zutil.notify("Rekod telah berjaya dihantar");
                        this.$inertia.visit(
                            this.$route("kutipan.resit.index") +
                                "?resit_id=" +
                                res
                        );
                    })
                    .catch((err) => {})
                    .finally(() => {

                        this.showOverlay= false
                    });
            }
            // }
        },

        profilhm() {
            this.dialogProfilhm.show = 1;
        },

        cariProfilhm() {

            this.dialog.loading = true;

            if (this.carian_profil_hm.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_kutipan + "carianprofil",
                        this.carian_profil_hm,
                        {}
                    )
                    .then((res) => {
                        this.draf_akaun = res.hm_akaun;
                        this.draf_inbois = res.inbois;
                        this.draf_perum = res.perumahan;
                        this.draf_pendidik = res.pendidikan;
                        this.draf_tuntutan = res.tuntutan;
                        this.dialog.loading = false;
                    });
                    
            }
        },

        // pilihProfilhm(dt){
        //     if (dt.no_inbois) {
        //       this.form.no_rujukan = dt.id;
        //       this.form_cari.no_rujukan = dt.no_inbois;
        //     }else{
        //           this.form.no_rujukan = dt.id;
        //           this.form_cari.no_rujukan = dt.no_hm;
        //       }
        //   this.Detail();
        // },

        cekPilih() {
            for (var i in this.draf_akaun) {
                this.draf_akaun[i].pilih_akaun = this.pilih_akaun;
            }
            for (var i in this.draf_inbois) {
                this.draf_inbois[i].pilih_inbois = this.pilih_inbois;
            }
            for (var i in this.draf_perum) {
                this.draf_perum[i].pilih_perum = this.pilih_perum;
            }
            for (var i in this.draf_pendidik) {
                this.draf_pendidik[i].pilih_pendidik = this.pilih_pendidik;
            }
            for (var i in this.draf_tuntutan) {
                this.draf_tuntutan[i].pilih_tuntutan = this.pilih_tuntutan;
            }
        },
        // cekPilihInbois(){
        //         for (var i in this.draf_inbois) {
        //             this.draf_inbois[i].pilih_inbois = this.pilih_inbois
        //         }
        //       },

        hantarRujukan() {
            // if (this.draf_akaun) {
            var no_hm = "";
            for (var i in this.draf_akaun) {
                if (this.draf_akaun[i].pilih_akaun == true) {
                    // this.form.hm_akaun_id = this.draf_akaun[i].id;
                    // // this.form.hm_cukai = res.data.hm_cukai;
                    // this.form.profil_nama = this.draf_akaun[i].profil_nama;
                    // this.form.keluasan = this.draf_akaun[i].keluasan;
                    // this.form.no_hm = this.draf_akaun[i].no_hm;
                    // this.form.jabatan_id = this.draf_akaun[i].jabatan.id;
                    // this.form.alamat = this.draf_akaun[i].alamat;
                    // this.form.daerah = this.draf_akaun[i].daerah_keterangan;
                    // this.form.hm_jenis = this.draf_akaun[i].hm_jenis_keterangan;
                    // this.form.hm_kegunaan = this.draf_akaun[i].hm_kegunaan_keterangan;
                    // this.form.mukim = this.draf_akaun[i].mukim_keterangan;
                    // this.form.tarikh_daftar = this.draf_akaun[i].tarikh_daftar;
                    // this.form.no_lot = this.draf_akaun[i].no_lot;
                    // this.form.jabatan = this.draf_akaun[i].jabatan_keterangan;
                    // this.form.nama = this.draf_akaun[i].nama;
                    // this.form.no_kp = this.draf_akaun[i].no_kp;
                    // this.form.unit_keterangan = this.draf_akaun[i].unit_keterangan;
                    var proses = 1;
                    for (var j in this.hm_cukai) {
                        if(this.draf_akaun[i].no_hm == this.hm_cukai[j].no_rujukan){
                            proses = 0;
                        }
                    }
                    if(proses == 1){
                        this.hm_cukai.push({
                            code : 2,
                            jenis : 'CUKAI',
                            jabatan_id: this.draf_akaun[i].jabatan.id,
                            no_rujukan: this.draf_akaun[i].no_hm,
                            amaun: this.draf_akaun[i].amaun,
                            amaun_asal: this.draf_akaun[i].amaun,
                            profil_id: this.draf_akaun[i].profil_id,
                            hm_cukai: this.draf_akaun[i].hm_cukai,
                            baki: this.draf_akaun[i].amaun,
                            profil_nama: this.draf_akaun[i].profil_nama,
                            nama: this.draf_akaun[i].nama,
                            id: this.draf_akaun[i].id,
                            rm_debit: this.draf_akaun[i].rm_debit,
                            rm_kredit: this.draf_akaun[i].rm_kredit,
                            rm_resit: this.draf_akaun[i].rm_resit,
                            rm_diskaun: this.draf_akaun[i].rm_diskaun,
                            rm_ampun_hasil: this.draf_akaun[i].rm_ampun_hasil,
                            baki: this.draf_akaun[i].baki,
                            sumber_akaun_id: this.draf_akaun[i].sumber_akaun_id,
                        });
                    }
                }

                this.form.hm_cukai = this.hm_cukai;
            }

            // }else{
            var no_inbois = "";
            for (var i in this.draf_inbois) {
                if (this.draf_inbois[i].pilih_inbois == true) {
                    this.form.inbois_id = this.draf_inbois[i].id;
                    this.form.amaun = this.draf_inbois[i].amaun;
                    this.form.no_inbois = this.draf_inbois[i].no_inbois;
                    this.form.jabatan_id = this.draf_inbois[i].jabatan.id;
                    this.form.profil_nama = this.draf_inbois[i].profil_nama;
                    this.form.alamat = this.draf_inbois[i].alamat;
                    this.form.jabatan = this.draf_inbois[i].jabatan_keterangan;
                    this.form.no_kp = this.draf_inbois[i].profil_no;
                    this.form.tarikh_inbois = this.draf_inbois[i].tarikh_inbois;
                    // for (var a in this.draf_inbois[i].butiran) {
                    var proses = 1;
                    for (var j in this.butiran) {
                        if(this.draf_inbois[i].no_inbois == this.butiran[j].no_rujukan){
                            proses = 0;
                        }
                    }
                    if(proses == 1){
                        this.butiran.push({
                            code : 1,
                            jenis : 'BIL PELBAGAI',
                            jabatan_id: this.draf_inbois[i].jabatan.id,
                            no_rujukan: this.draf_inbois[i].no_inbois,
                            akaun_id: this.draf_inbois[i].akaun_id,
                            amaun: this.draf_inbois[i].amaun,
                            profil_id: this.draf_inbois[i].profil_id,
                            butiran: this.draf_inbois[i].butiran,
                            baki: this.draf_inbois[i].amaun,
                            profil_nama: this.draf_inbois[i].profil_nama,
                            id: this.draf_inbois[i].id,
                            vot_id: this.draf_inbois[i].vot_id,
                        });
                    }
                    // }

                    this.form.butiran = this.butiran;
                }
            }

            for (var i in this.draf_perum) {

                if (this.draf_perum[i].pilih_perum == true) {
                    var proses = 1;
                    for (var j in this.hm_cukai) {
                        if(this.draf_perum[i].no_akaun == this.hm_cukai[j].no_rujukan){
                            proses = 0;
                        }
                    }
                    if(proses == 1){
                        this.hm_cukai.push({
                            code : 5,
                            jenis : 'PERUMAHAN',
                            jabatan_id: 15,
                            no_rujukan: this.draf_perum[i].no_akaun,
                            amaun_asal: this.draf_perum[i].kadar_bulanan,
                            amaun: this.draf_perum[i].kadar_bulanan,
                            profil_id: this.draf_perum[i].profil_id,
                            hm_cukai: [],
                            baki: this.draf_perum[i].amaun_baki,
                            profil_nama: this.draf_perum[i].nama,
                            nama: this.draf_perum[i].nama,
                            id: this.draf_perum[i].model_id,
                            rm_debit: null,
                            rm_kredit: null,
                            rm_resit: null,
                            rm_diskaun: null,
                            rm_ampun_hasil: null,
                            sumber_akaun_id: null,
                            alamat : this.draf_perum[i].alamat,
                            no_kp : this.draf_perum[i].no_id, 
                        });
                    }
                    this.form.hm_cukai = this.hm_cukai;
                }
            }

            for (var i in this.draf_pendidik) {

                if (this.draf_pendidik[i].pilih_pendidik == true) {
                    var proses = 1;
                        for (var j in this.hm_cukai) {
                            if(this.draf_pendidik[k].NO_LBNK == this.hm_cukai[j].no_rujukan){
                                proses = 0;
                            }
                        }
                        if(proses == 1){
                            this.hm_cukai.push({
                                code : 3,
                                jenis : 'PENDIDIKAN',
                                jabatan_id: 160,
                                no_rujukan: this.draf_pendidik[i].NO_LBNK,
                                amaun_asal: this.draf_pendidik[i].ANSURAN_BULANAN,
                                amaun: this.draf_pendidik[i].ANSURAN_BULANAN,
                                profil_id: this.draf_pendidik[i].profil_id,
                                hm_cukai: [],
                                baki: this.draf_pendidik[i].ANSURAN_BULANAN,
                                profil_nama: this.draf_pendidik[i].NAMA_PENUH,
                                nama: this.draf_pendidik[i].NAMA_PENUH,
                                id: this.draf_pendidik[i].model_id,
                                rm_debit: null,
                                rm_kredit: null,
                                rm_resit: null,
                                rm_diskaun: null,
                                rm_ampun_hasil: null,
                                sumber_akaun_id: null,
                                alamat : this.draf_pendidik[i].ALAMAT_SURAT,
                                no_kp : this.draf_pendidik[i].IC_BARU, 
                            });
                    }
                    this.form.hm_cukai = this.hm_cukai;
                }
            }

            for (var i in this.draf_tuntutan) {

                if (this.draf_tuntutan[i].pilih_tuntutan == true) {
                    var proses = 1;
                        for (var j in this.hm_cukai) {
                            if(this.draf_tuntutan[i].no_rujukan == this.hm_cukai[j].no_rujukan){
                                proses = 0;
                            }
                        }
                        if(proses == 1){
                            this.hm_cukai.push({
                                code : 4,
                                jenis : 'TUNTUTAN',
                                jabatan_id: 160,
                                no_rujukan: this.draf_tuntutan[i].no_rujukan,
                                amaun_asal: this.draf_tuntutan[i].jumlah_amaun,
                                amaun: this.draf_tuntutan[i].jumlah_amaun,
                                profil_id: this.draf_tuntutan[i].profil_id,
                                hm_cukai: [],
                                baki: this.draf_tuntutan[i].jumlah_baki,
                                profil_nama: this.draf_tuntutan[i].nama,
                                nama: this.draf_tuntutan[i].nama,
                                id: this.draf_tuntutan[i].model_id,
                                rm_debit: null,
                                rm_kredit: null,
                                rm_resit: null,
                                rm_diskaun: null,
                                rm_ampun_hasil: null,
                                sumber_akaun_id: null,
                                alamat : this.draf_tuntutan[i].alamat,
                                no_kp : this.draf_tuntutan[i].no_id, 
                            });
                    }
                    this.form.hm_cukai = this.hm_cukai;
                }
            }

            // }
            this.cekAmaunButiran();
            this.cekAmaunCukai();
            this.dialogProfilhm.show = false;
            this.reset();
        },
        totalKenaBayar(){
           this.form.cara_bayaran[0].amaun = this.amaun_jumlah_cukai + this.amaun_butiran
           this.cekAmaunBayar(this.form.cara_bayaran[0])
        },
        reset() {
            this.carian_profil_hm = { q: "" };
            this.draf_inbois = [
                {
                    jabatan_keterangan: "",
                    no_inbois: "",
                    keluasan: "",
                    pilih_inbois: "",
                },
            ];
            this.draf_akaun = [
                {
                    jabatan_keterangan: "",
                    no_hm: "",
                    amaun: "",
                    pilih_inbois: "",
                },
            ];
            this.draf_perum = [
                {
                    jabatan_keterangan: "",
                    no_akaun: "",
                    kadar_bulanan: "",
                    pilih_perum: "",
                },
            ];
            this.draf_pendidik = [
                {
                    jabatan_keterangan: "",
                    NO_LBNK: "",
                    amaun: "",
                    pilih_pendidik: "",
                },
            ];
             this.draf_tuntutan = [
                {
                    jabatan_keterangan: "",
                    no_rujukan: "",
                    amaun: "",
                    pilih_tuntutan: "",
                },
            ];
        },

       profil(){
          this.dialogProfil.show = 1
        },

       
        cariProfil(){
          if(this.carian_profil.q.length > 1){
            this.$zcomm.post(this.service_bil_pelbagai+"lookup/profil", this.carian_profil, {})
            .then(res => {
              console.log(res)
                this.profils = res
              })
          }
        },

        pilihProfil(dt){
          this.form.profil_keterangan = dt.label;
          this.form_cari.id = dt.value;
          this.profilDetail();
        },

         
      poskodDetail() {
          
        this.$zcomm.get(this.service_bil_pelbagai+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
                  this.form_profil.negeri = res.negeri;
                  this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                  this.form_profil.bandar = res.bandar;
                  this.form_profil.lkp_jenis_alamat_id = 1;
                });
        },
      profilDetail() {
        // alert('w234')
      
          this.$zcomm.get(this.service_bil_pelbagai+'profil/'+this.form_cari.id).then(res => {
                  this.form.profil_id = res.id;
                  this.form.no_id = res.no_id;
                  this.form.nama = res.nama;
                  this.form.alamat1 = res.alamat1;
                  this.form.alamat2 = res.alamat2;
                  this.form.alamat3 = res.alamat3;
                  this.form.poskod = res.poskod;
                  this.form.bandar = res.bandar;
                  this.form.negeri = res.negeri;
                  this.form.kategori = res.kategori;
                  
                });
          this.dialogProfil.show = false
        },
    
    submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          // this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                          this.form.profil_keterangan = res.no_id+'|'+res.nama;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
        getAkauns() {
            this.$zcomm.get(this.service_utiliti+'lookup/akaun_akhir').then(res => {
                  this.akauns = res;
                });
        },

        getBayaran() {
            this.$zcomm.get(this.service_utiliti+'lookup/cara_bayar_kaunter').then(res => {
                  this.akauns = res;
                });
        },

        Vot_akaun(da){
        
            if(da.ind_vot_id == 0){
                da.ind_vot_id = 1
            }else{
                da.ind_vot_id = 0
            }
            for (var a in this.akauns) {
                if(da.akaun_id == this.akauns[a].value){
                    da.vot_id = this.akauns[a].vot;
                }
            }
         },

    },
    watch: {
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },

    },
    mounted() {
        this.bukaKaunter();
        this.caraBayar();
        this.getAkauns();
        this.form.cara_bayaran = [
            {
                lkp_cara_bayaran_id: null,
                lkp_bank_id: null,
                no_dokumen: null,
                cawangan_bank: null,
                tarikh_cek: null,
                tarikh_eft: null,
                amaun: null,
            },
        ];
    },
};
</script>
